<template>
  <v-text-field
    :label="label"
    :value="value"
    :rules="inputNameRules"
    :hint="hint"
    @input="$emit('input-change', { name: name, value: $event })"
  ></v-text-field>
</template>

<script>
export default {
  name: 'InputField',

  props: {
    name: { type: String, required: true, default: '' },
    label: { type: String, required: false, default: '' },
    value: { type: String, required: false, default: '' },
    hint: { type: String, required: false, default: '' }
  },

  data: () => ({
    inputNameRules: [v => !!v || 'Required']
  })
}
</script>
